import { render } from "./PatientAccountabilityOverview.vue?vue&type=template&id=251cfc6d&scoped=true"
import script from "./PatientAccountabilityOverview.vue?vue&type=script&lang=js"
export * from "./PatientAccountabilityOverview.vue?vue&type=script&lang=js"

import "./PatientAccountabilityOverview.vue?vue&type=style&index=0&id=251cfc6d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251cfc6d"]])

export default __exports__